import { render } from "./VirtualMailboxesPasswordItem.vue?vue&type=template&id=0ad2b000"
import script from "./VirtualMailboxesPasswordItem.vue?vue&type=script&lang=ts"
export * from "./VirtualMailboxesPasswordItem.vue?vue&type=script&lang=ts"
script.render = render

export default script